module.exports = __webpack_public_path__ + "f0517ce032ccf1411dd541b3fca5ef37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/19.jpg
// module id = 1345
// module chunks = 47